export const EXTERNAL_SERVICE_PORTAL_IDS: Record<string, string> = {
  Hyly: "external-services-slot-hyly",
};
